import axios from '@/lib/axios';
import { MoneyForwardSetting, UserInvitation, Workspace } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 2220. MoneyForward連携設定登録
 * [POST] /workspaces/:identifier/money_forward_setting
 */
type Props = {
  identifier: string;
  client_id: string;
  client_secret: string;
  code: string;
};
const createMoneyForwardSetting = (props: Props): Promise<MoneyForwardSetting> => {
  return axios.post(`/api/workspaces/${props.identifier}/money_forward_setting`, props);
};

export const useCreateMoneyForwardSetting = () => {
  return useMutation({
    mutationFn: createMoneyForwardSetting,
  });
};
